import { render, staticRenderFns } from "./ViveLatino.vue?vue&type=template&id=761ed4ec"
import script from "./ViveLatino.vue?vue&type=script&lang=js"
export * from "./ViveLatino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports